import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class  BusinessService{
  // API Instance
  configConnection: any = new ConfigConnection();

  get(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  create(business){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.post(`${_.configConnection.apiInstance}business`, business, config);
  }

  edit(business, idBusiness){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.put(`${_.configConnection.apiInstance}business/${idBusiness}`, business, config);
  }

  getById(idBusiness){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business/${idBusiness}`, config);
  }

  delete_business(idBusiness){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.delete(`${_.configConnection.apiInstance}business/${idBusiness}`, config);
  }

  getInactive(pageOffset, itemsPerPage){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business/inactive?offset=${pageOffset}&limit=${itemsPerPage}`, config);
  }

  active_business(idBusiness, reactivate){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business/${idBusiness}/reactivate`, config);
  }
}
